import type { FC, PropsWithChildren } from 'react';
import { Suspense } from 'react';
import LoadingDialog from '../LoadingDialog/LoadingDialog';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
  text?: string ;
}

const Sus: FC<PropsWithChildren<IProps>> = ({
  children,
  text = 'Initialising...',
}) => {
  return (
    <Suspense fallback={<LoadingDialog><CircularProgress size='small'/>{text}</LoadingDialog>}>
      <>{children}</>
    </Suspense>
  );
};

export default Sus;
